import React from "react";
import { CenterContentContainer, ContentHeaderView, PageContainer, PageContentView } from "components/shared";

import "./styles.css";

/**
 * @function StoppedNumbersPage
 * @return {React.Component}
 * @exported true
 * @description The main component for StoppedNumbersPage
 */
export default function StoppedNumbersPage(props) {
    return (
        <PageContainer className="stopped-numbers-page">
            <PageContentView>
                <CenterContentContainer>
                    <ContentHeaderView text="Reactivate Authentication Number" />
                    <div className="content-container">
                        <p>There are currently no numbers blocked from receiving authentication codes.</p>
                    </div>
                </CenterContentContainer>
            </PageContentView>
        </PageContainer>
    )
}
